import { interpolate } from '@lemonade-hq/uniclient-chat';
import type { Method } from 'axios';

export function buildPayload(
  payloadMap: Record<string, string>,
  answers: Record<string, unknown>,
): Record<string, string> {
  return Object.entries(payloadMap).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: interpolate(value, answers),
    };
  }, {});
}

export async function makeAsyncCall({
  url,
  payload,
  headers,
  method = 'POST',
  withCredentials,
}: {
  readonly url: string;
  readonly method?: Method;
  readonly payload: Record<string, unknown>;
  readonly headers?: Record<string, string>;
  readonly withCredentials?: boolean;
}): Promise<Response> {
  return await fetch(url, {
    method,
    body: JSON.stringify(payload),
    headers,
    credentials: withCredentials ? 'include' : undefined,
  });
}
